import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import M from 'materialize-css/dist/js/materialize';
import { withRouter } from 'react-router-dom';
import $ from 'jquery';
import { withTranslation } from 'react-i18next';
import SecurityService from '../../services/SecurityService';
import MessageService from '../../services/MessageService';
import { startLoading, endLoading } from '../../actions/loadingAction';
import * as userAction from '../../actions/userAction';
import InputUI from '../../components/UI/InputUI';
import ButtonUI from '../../components/UI/ButtonUI';
import { getPathApp, checkOriginInternal, translate, changeLanguage, getUrlRepositoryApi, checkOriginNonProd, autoFocus } from '../../utils/util';
import { validateInputsRequired, onValueChange } from '../../utils/handleChangeHooks';
import logo from '../../assets/images/logo_logistics.png';
import flagBrazil from '../../assets/images/flags/brazil.png';
import flagUS from '../../assets/images/flags/us.png';
import flagArgentina from '../../assets/images/flags/argentina.png';
import flagItaly from '../../assets/images/flags/italy.png';
import temaBlack from '../../assets/images/temas/temaBlack.png';
import temaDefault from '../../assets/images/temas/temaPadrao.png';
import './login.css';

const Login = (props) => {
    const [user, setUser] = useState({ userName: 'fiatauto\\', password: '' });
    const [type, setType] = useState('password');

    useEffect(() => {
        $('#header, .drag-target, .sidenav-overlay, #toast-container').hide();
        autoFocus("user")
        // eslint-disable-next-line
    }, []);

    const onChange = (event) => {
        onValueChange(event, user, setUser);
    };

    const handleFormKeyDown = (e) => {
        if (e.key === 'Enter') {
            submit();
        }
    }

    const submit = () => {
        if (validateInputsRequired("formLogin")) {
            props.showLoading();
            props.login(user, (authenticated) => {
                loginUser(authenticated);
            });
        }
    }

    const urlRepository = () => {
        const url = getUrlRepositoryApi(window);
        const link = document.getElementById("myLink");
        link.setAttribute("href", `${url}/api/repository/file/download?FileName=mobile/apk/app-release.apk`);
        return false;
    }

    const loginUser = (authenticated) => {
        const pathurl = getPathApp(window);
        props.hideLoading();
        if (authenticated === true) {
            props.history.push(`${pathurl}/home`);
            if (navigator.userAgent === 'logisticspwa') {
                props.sendTokenDevice();
            }
        } else {
            M.toast({ html: translate('invalid-user-password', 'login'), classes: 'red' });
        }
    }

    const isInternal = () => {
        const internal = checkOriginInternal(window);
        return internal;
    }

    const showHide = (e) => {
        e.preventDefault();
        e.stopPropagation();
        setType(type === 'text' ? 'password' : 'text');
    }

    return (
        <div>
            <div className="container center" style={{ paddingTop: '60px' }}>
                <img src={`${logo}`} alt="Logo Logistics" />
            </div>
            <div className="container" style={{ paddingTop: '15px' }}>
                <div className="card card-login">
                    <form onKeyDown={handleFormKeyDown} id="formLogin" className="card-content">
                        <div className="input-field">
                            <i className="material-icons prefix">perm_identity</i>
                            <InputUI
                                id="user"
                                className="validate"
                                required
                                type="text"
                                name="userName"
                                validation-field="userName"
                                value={user.userName}
                                onChange={onChange}
                                minLength={3}
                            />
                            <label htmlFor="user" className="required">
                                {translate('username', 'login')}
                            </label>
                        </div>
                        <div className="input-field">
                            <i className="material-icons prefix">lock</i>
                            <InputUI
                                id="password"
                                className="validate"
                                required
                                type={type}
                                name="password"
                                value={user.password}
                                onChange={onChange}
                                minLength={3}
                            />
                            <label htmlFor="password" className="required">
                                {translate('password', 'login')}
                            </label>
                            <span className="field-icon"
                                onClick={showHide}>
                                <span className="material-icons">
                                    {type === 'text' ? 'visibility' : 'visibility_off'}
                                </span>
                            </span>
                        </div>
                        <div className="center-align">
                            <ButtonUI name="btnLogin"
                                large="true"
                                onClick={() => submit()}
                                text={translate('btn-login', 'login')} />
                        </div>
                    </form>
                    <div className="card-action center">
                        <button
                            onClick={() => { changeLanguage('pt-BR'); }}
                            className="btn btn-flat btn-flag bgTransparent waves-effect waves-light"
                            type="button"
                            name="lngPtBR"
                        >
                            <img src={flagBrazil} alt="Language Portuguese" />
                        </button>
                        <button
                            onClick={() => { changeLanguage('en'); }}
                            className="btn btn-flat btn-flag bgTransparent waves-effect waves-light"
                            type="button"
                            name="lngEN"
                        >
                            <img src={flagUS} alt="Language English" />
                        </button>
                        <button
                            onClick={() => { changeLanguage('es-AR'); }}
                            className="btn btn-flat btn-flag bgTransparent waves-effect waves-light"
                            type="button"
                            name="lngES"
                        >
                            <img src={flagArgentina} alt="Language Spanish" />
                        </button>
                        <button
                            onClick={() => { changeLanguage('it'); }}
                            className="btn btn-flat btn-flag bgTransparent waves-effect waves-light"
                            type="button"
                            name="lngIt"
                        >
                            <img src={flagItaly} alt="Language Italy" />
                        </button>
                    </div>
                    {
                        checkOriginNonProd(window) &&
                        <div className="card-action center">
                            <button
                                onClick={() => {
                                    localStorage.setItem("THEME", "dark");
                                    window.location.reload();
                                }}
                                className="btn btn-flat btn-flag bgTransparent waves-effect waves-light"
                                type="button"
                            >
                                <img src={temaBlack} alt="Tema Dark" />
                            </button>
                            <button
                                onClick={() => {
                                    localStorage.setItem("THEME", "white");
                                    window.location.reload();
                                }}
                                className="btn btn-flat btn-flag bgTransparent waves-effect waves-light"
                                type="button"
                            >
                                <img src={temaDefault} alt="Tema Default" />
                            </button>
                        </div>
                    }

                </div>
            </div>
            <div className="center second-text-color">
                <a id="myLink" onClick={urlRepository} href="/#"><i className="mdi mdi-cellphone-android" /> Download App</a>
            </div>
            {
                isInternal() ? (<div className="center second-text-color"><i className="material-icons">domain</i> Plant</div>) : null
            }
        </div>
    );
}

const mapStateToProps = (state) => {
    return {
        user: state.userReducer.user,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        login: (user, callback) => {
            dispatch(SecurityService.login(user, callback));
        },
        sendTokenDevice: () => {
            dispatch(MessageService.AddDeviceToken());
        },
        showLoading: () => {
            dispatch(startLoading());
        },
        hideLoading: () => {
            dispatch(endLoading());
        },
        setTheme: (theme) => {
            dispatch(userAction.setTheme(theme));
        }
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withTranslation()(Login)));
